import { methodGet } from './methods';

import { API_INFO } from '../constants';

export const getLimitedDeliveries = async (query) => {
  return methodGet(API_INFO + `transport/province-limited-deliveries/`, query);
};

export const getShippingProviders = async () => {
  return methodGet(API_INFO + `transport/transport-companies/`);
};